//Borrowed from here http://www.17educations.com/angularjs-2/google-map-directions-display-angular-2/

import { Component, Input } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { Subject, Subscription } from 'rxjs';
import { ConfigService } from '../Services/ConfigService';
import { DateTime } from 'luxon';

@Component({
	selector: 'google-map-directions',
	template: "<div class='text-center p-2' *ngIf='_showMiles && !_useStraightLine'> {{totalMiles  | number : '1.2-2'}} Miles" +
		"<span *ngIf='_showTime&& !_useStraightLine'> Approx {{ totalTime | number : '1.0' }} Minutes</span>"+
		'</div>',
})
export class DirectionsMapDirective {

	get totalTime(): number {
		var iseconds = 0;
		this.mapPaths.forEach(lh => {
			iseconds += lh.Minutes;
		});
		return iseconds;
	}

	get totalMiles(): number {
		var meters = 0;
		this.mapPaths.forEach(lh => {
			meters += lh.Meters;
		});
		return (meters / 1000) / this.MilesToKM;
	}

	private MilesToKM: number = 1.60934;

	public _showTime: boolean = false;

	@Input()
	set showTime(val: boolean) {
		this._showTime= val;
	}

	public _showMiles: boolean = false;

	@Input()
	set showMiles(val: boolean) {
		this._showMiles = val;
	}

	private _streetView: boolean = false;

	@Input()
	set streetView(val: boolean) {
		this._streetView = val;
		if (this._map) {
			this._map.setOptions({
				streetViewControl: this._streetView
			});
		}
	}

	@Input()
	set map(val: GoogleMap) {
		this.setMap(val.googleMap);
	}

	_highlightedIDs: string[] = [];
	get highlightedIDs(): string[] {
		return this._highlightedIDs;
	}

	@Input()
	set highlightedIDs(val: string[]) {
		this._highlightedIDs = val;
		this.highlightThings();
	}

	shouldBeHighlighted(pt: GmapPoint): boolean {
		var isOk = false;
		if ((pt.ids ?? []).length) {
			pt.ids.forEach(id => {
				if (!isOk) {
					if (!this.configData.IsEmptyGuid(id)) {
						if (this.highlightedIDs.indexOf(id) >= 0) {
							isOk = true;
						}
					}
				}
			});
		}
		return isOk;
	}

	highlightThings() {
		if (this.mapPaths) {

			this.mapPaths.forEach(path => {
				path.allPoints.forEach(pt => {
					var mkr = pt.marker;
					if (mkr) {
						var content: any = mkr.content;
						if (this.shouldBeHighlighted(pt)) {
							//highlight it
							content.firstChild.style.fill = '#FFFF00';
							content.lastChild.style.fill = '#000';
							mkr.style.zIndex = '9999';
						} else {
							content.firstChild.style.fill = pt.color;
							content.lastChild.style.fill = '#FFF';
							if (pt.markerTypes.indexOf(GmapMarkerTypeEnum.Start) >= 0 || pt.markerTypes.indexOf(GmapMarkerTypeEnum.Finish) >= 0) {
								mkr.style.zIndex = '1';
							} else {
								mkr.style.zIndex = '10';
							}
							//unhighlight it
						}
					}
				});
			});
		}
	}
	getmap(): google.maps.Map {
		return this._map;
	}
	setMap(map: google.maps.Map) {
		this._map = map;
		if (this._map) {
			this._map.setOptions({
				mapId: this.getMapID(),
				streetViewControl: this._streetView,
				fullscreenControl: false,
				styles: [
					{
						featureType: 'poi',
						stylers: [{
							visibility: 'off'
						}]
					},
					{
						"featureType": "poi.business",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					},
				]
			});
		}
	}

	getMapID() {
		return this.configData.mapsID;
	}
	private _map: google.maps.Map;
	private _directionsService: google.maps.DirectionsService;
	private _changes = new Subject<any>();


	_useSymbols: boolean = false;
	@Input()
	set useSymbols(val: boolean) {
		if (this._useSymbols != val) {
			this._useSymbols = true;
		}
	}
	_useStraightLine: boolean = false;
	@Input()
	set useStraightLine(val: boolean) {
		if (this._useStraightLine != val) {
			this._useStraightLine = true;
		}
	}

	private readonly _polylineOptions = {
		strokeWeight: 8,
		strokeOpacity: 0.7,
		strokeColor: '#00468c'
	};



	constructor(
		private configData: ConfigService) {

		this._directionsService = new google.maps.DirectionsService();
	}

	mapPaths: GmapDirectionsDataHolder[] = [];

	setDataBulk(bulkData: GmapDirectionsDataHolder[], clearFirst: boolean) {
		if (clearFirst) {
			this.mapPaths = [];
		}
		bulkData.forEach(mapData => {
			this.mapPaths.push(mapData);
		});
		this.ngOnChanges();
	}
	setData(mapData: GmapDirectionsDataHolder) {
		this.mapPaths.push(mapData);
		var bounds = new google.maps.LatLngBounds();
		this.addPathToMap(mapData, bounds);
		if (mapData) {
			if (!bounds.isEmpty()) {
				this._map.fitBounds(bounds);
				this._map.panToBounds(bounds);
			}
		}
	}

	minZoom = 11;

	minTruckDistanceInKM = .1;
	isTruckPointFarEnoughToShow(pt1: google.maps.LatLngLiteral, pt2: google.maps.LatLngLiteral): boolean {
		if (!pt2) {
			return false;
		}
		if (!pt1) {
			return true;
		}
		if (pt1.lat == pt2.lat && pt1.lng == pt2.lng) {
			return false;
		}
		return true;
		return this.getDistanceFromLatLonInKm(pt1.lat, pt1.lng, pt2.lat, pt2.lng) > this.minTruckDistanceInKM;
		//var isSame = pt2 && pt1.lat == pt2.lat && pt1.lng == pt2.lng;
		//return !isSame;
	}

	//https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula
	getDistanceFromLatLonInKm(lat1: number, lon1: number, lat2: number, lon2: number) {
		var R = 6371; // Radius of the earth in km
		var dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
		var dLon = this.deg2rad(lon2 - lon1);
		var a =
			Math.sin(dLat / 2) * Math.sin(dLat / 2) +
			Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
			Math.sin(dLon / 2) * Math.sin(dLon / 2)
			;
		var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		var d = R * c; // Distance in km
		return d;
	}

	deg2rad(deg: number) {
		return deg * (Math.PI / 180)
	}
	getNearestPoint(pt: google.maps.LatLng): GmapTruckPoint {
		var sItem = null;
		if (pt) {
			var distance = 100000000;
			this._truckPoints.forEach(item => {
				var newDist = this.getDistanceFromLatLonInKm(pt.lat(), pt.lng(), item.location.lat, item.location.lng);
				if (newDist < distance) {
					distance = newDist;
					sItem = item;
				}
			});
		}
		return sItem;
	}


	infoWindow: google.maps.InfoWindow = null;
	truckPath: google.maps.Polyline = null;
	_truckPoints: GmapTruckPoint[] = [];
	_truckMarkers: GmapTruckPoint[] = [];

	setTruckMarkers(markers: GmapTruckPoint[]) {
		if (this._truckMarkers) {
			this._truckMarkers.forEach(mark => {
				if (mark.marker) {
					mark.marker.map = null;
				}
			});
		}
		this._truckMarkers = [];

		if (markers) {
			markers.forEach(mark => {
				if (!mark.marker) {
					const svgString = "M48 0C21.5 0 0 21.5 0 48L0 368c0 26.5 21.5 48 48 48l16 0c0 53 43 96 96 96s96-43 96-96l128 0c0 53 43 96 96 96s96-43 96-96l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-64 0-32 0-18.7c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7L416 96l0-48c0-26.5-21.5-48-48-48L48 0zM416 160l50.7 0L544 237.3l0 18.7-128 0 0-96zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z";
					const pinSvgString =
						'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" style="width: 32px; height: 25px;">' +
						'<path d="' + svgString + '" stroke="#000" fill="' + mark.color +
						'" stroke-width="25" stroke-linecap="round" stroke-linejoin="round"></path>' +
						'</svg>';


					const parser = new DOMParser();
					const pinSvg = parser.parseFromString(
						pinSvgString,
						'image/svg+xml'
					).documentElement;

					//var markerImage: google.maps.marker.PinElementOptions = {  // https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerLabel
					//	glyph: pinSvg,
					//	background: mark.color,
					//	borderColor: mark.color,
					//	scale: 4
					//};
					//var markerPinElement = new google.maps.marker.PinElement(markerImage).element;


					mark.marker = new google.maps.marker.AdvancedMarkerElement({
						position: mark.location,
						map: this._map,
						content: pinSvg,
						// @ts-ignore
						anchorLeft: "-50%",
						anchorTop: "-100%",
					});

				} else {
					mark.marker.map = this._map;
				}
				this._truckMarkers.push(mark);
			});
		}
	}

	setTruckMap(truckMapPoints: GmapTruckPoint[], color: string) {
		this.setTruckMarkers(null);
		if (!truckMapPoints?.length) {
			if (this.truckPath) {
				this.truckPath.setMap(null);
			}
			this._truckPoints = [];
		} else {
			if (this.truckPath) {
				this.truckPath.setMap(null);
			}
			this._truckPoints = [];
			var lastPoint: GmapTruckPoint = null;

			truckMapPoints.forEach(tPt => {
				if (this.isTruckPointFarEnoughToShow(lastPoint?.location, tPt?.location)) {
					this._truckPoints.push(tPt);
					lastPoint = tPt;
				}
			});
			var points = this._truckPoints.map(a => a.location);
			const flightPath = new google.maps.Polyline({
				path: points,
				geodesic: true,
				strokeWeight: 4,
				strokeOpacity: 0.7,
				strokeColor: color
			});
			flightPath.setMap(this._map);
			this.truckPath = flightPath;
			if (lastPoint) {
				this.setTruckMarkers([lastPoint]);
			}
			var thisHolder = this;
			if (!this.infoWindow) {
				var wdw = new google.maps.InfoWindow({
					//headerDisabled: false,
					maxWidth: 300,
				});
				thisHolder.infoWindow = wdw;
			}
			google.maps.event.addListener(this.truckPath, 'mouseover', (evt: any) => {
				var closePt = thisHolder.getNearestPoint(evt.latLng);
				if (closePt) {
					var node = document.createElement('div');
					node.innerHTML = 'As of ' + DateTime.fromISO(closePt.time.toString()).toLocaleString(DateTime.DATETIME_MED);
					node.style.padding = '15px';
					node.style.lineHeight = '1.35';
					node.style.overflow = 'hidden';
					node.style.whiteSpace = 'nowrap';
					thisHolder.infoWindow.setContent(node);
					thisHolder.infoWindow.setPosition(closePt.location);
					thisHolder.infoWindow.open(thisHolder._map);

					var wrapDiv: any = document.getElementsByClassName('gm-style-iw-d');
					if (wrapDiv) {
						for (let i = 0; i < wrapDiv.length; i++) {
							wrapDiv[0].attributeStyleMap.clear();
						}
					}
				}
			});
			google.maps.event.addListener(this.truckPath, 'mouseout', () => {
				if (thisHolder.infoWindow) {
					thisHolder.infoWindow.close();
				}
			});
		}
	}
	ngOnChanges() {
		this._changes.next({});
		this.remap();

	}

	clear() {
		if (this.mapPaths) {
			this.mapPaths.forEach(mp => {
				mp.clearMap();
			});
		}
		this.mapPaths = [];
		this._changes.next({});

	}

	setMinZoom() {
		console.log('Check Zoom: ' + this._map.getZoom());
		if (this._map.getZoom() > this.minZoom) {
			this._map.setZoom(this.minZoom);
			console.log('Minimum Zoom: ' + this.minZoom);
		}
	}
	remap() {
		var bounds = new google.maps.LatLngBounds();
		this.mapPaths.forEach(lineHolder => {
			this.addPathToMap(lineHolder, bounds);
		});
		if (this.mapPaths.length) {
			var fit = true;
			if (this.mapPaths.length == 1) {
				var path = this.mapPaths[0];
				var single = path.allPoints?.length == 1;
				if (!single) {
					single = path.allPoints?.length == 2 && !this.isDifferentLocation(path.allPoints[0], path.allPoints[1]);
				}
				if (single) {
					var thisHolder = this;
					setTimeout(() => {
						thisHolder._map.setCenter(path.allPoints[0].getAsLocation());
						thisHolder.setMinZoom();
					}, 1000);
					fit = false;
				}
			}
			if (fit) {
				if (!bounds.isEmpty()) {
					this._map.fitBounds(bounds);
				}
			}
		}
	}
	isDifferentLocation(source: GmapPoint, thisPt: GmapPoint): boolean {
		if (source && thisPt) {
			var sLoc = source.getAsLocation();
			var eLoc = thisPt.getAsLocation();
			if (sLoc && eLoc && sLoc.lat == eLoc.lat && sLoc.lng == eLoc.lng) {
				return false;
			}
		}
		return true;
	}

	drawStraightLines(lineHolder: GmapDirectionsDataHolder) {
		var points: (google.maps.LatLng | google.maps.LatLngLiteral)[] = [];
		lineHolder.allPoints.forEach(pt => {
			var loc = pt.getAsLocation();
			points.push(loc);

		});
		if (points.length > 0) {
			var opts = Object.assign({
				path: points,
				geodesic: true,
			}, this._polylineOptions, {
				strokeColor: lineHolder.color,
			});
			const flightPath = new google.maps.Polyline(opts);
			lineHolder.straightLineHolder = flightPath;
			flightPath.setMap(this._map);
		}
	}

	addPathToMap(lineHolder: GmapDirectionsDataHolder, bounds: google.maps.LatLngBounds) {
		var thisHolder = this;
		if (lineHolder.startingPoint && lineHolder.endingPoint && lineHolder.wayPoints) {
			var sub = this._changes.subscribe(() => lineHolder.clearMap());
			lineHolder.clearSubscription = sub;
			if (!lineHolder.onlyPoints) {
				if (lineHolder.wayPoints.length <= 25) { //Gmaps limits to 25 way points
					lineHolder.addMarkers(this._useSymbols, this._map, bounds);
					if (lineHolder.directionsResult && lineHolder.directionsRenderer) {
						//we already have the results
						if (this._useStraightLine || !lineHolder.directionsResult?.routes?.length) {
							this.drawStraightLines(lineHolder);
						} else {
							lineHolder.directionsRenderer.setMap(this._map);
							lineHolder.directionsRenderer.setDirections(lineHolder.directionsResult);
						}
					} else {
						this.routeRequest(lineHolder, false);

					}
					this.highlightThings();
				}
			} else {
				lineHolder.addMarkers(this._useSymbols, this._map, bounds);
				this.highlightThings();
			}
		}
	}

	routeRequest(lineHolder: GmapDirectionsDataHolder, includeWalking: boolean) {
		const req = lineHolder.buildDirectionsRequest(includeWalking);
		var thisHolder = this;
		var checkAgain = !includeWalking;
		this._directionsService.route(req, (response: google.maps.DirectionsResult, status: google.maps.DirectionsStatus) => {
			if (status === google.maps.DirectionsStatus.OK) {
				if (response.routes?.length) {
					checkAgain = false;
					lineHolder.directionsResult = response;

					lineHolder.Meters = 0;
					if (thisHolder._showMiles) {
						if (lineHolder.directionsResult?.routes?.length) {
							lineHolder.directionsResult.routes[0]?.legs?.forEach(leg => {
								if (leg.distance) {
									lineHolder.Meters += leg.distance.value;
								}
							});
						}
					}
					if (thisHolder._showTime) {
						if (lineHolder.directionsResult?.routes?.length) {
							lineHolder.directionsResult.routes[0]?.legs?.forEach(leg => {
								if (leg.duration) {
									lineHolder.Minutes += leg.duration.value / 60;
								}
							});
						}
					}
					var opts = Object.assign({}, this._polylineOptions, {
						strokeColor: lineHolder.color,
					});

					const directionsDisplay: any = new google.maps.DirectionsRenderer({
						draggable: false,
						suppressMarkers: true,
						polylineOptions: opts
					});
					lineHolder.directionsRenderer = directionsDisplay;

					if (this._useStraightLine) {
						this.drawStraightLines(lineHolder);
					} else {
						directionsDisplay.setMap(this._map);
						directionsDisplay.setDirections(lineHolder.directionsResult);
					}
				}
			}
			if (checkAgain) {
				this.routeRequest(lineHolder, true);
			}
		});
	}
}
export class GmapMarkerTypeEnum {

	static Pickup: number = 0;
	static Assembly: number = 1;
	static Delivery: number = 2;
	static Break: number = 3;
	static WarehousePickup: number = 4;
	static WarehouseDelivery: number = 5;
	static Start: number = 6;
	static ServiceOnly: number = 7;
	static Finish: number = 8;
	static Completed: number = 9;
	static Cancelled: number = 10;
	static Removal: number = 11;
	static Exchange: number = 12;
	static NotifyItems: number = 13;
	static IsWarehouseOrCustomerLocation: number = 14;


}

export class GmapTruckPoint {
	location?: google.maps.LatLngLiteral;
	time?: Date;
	extraData: string;
	color: string;
	marker: google.maps.marker.AdvancedMarkerElement;
}
export class GmapPoint {

	static MakePoint(loc: google.maps.LatLngLiteral, col: string, stopNum: string, ids: string[] = []) {
		if (loc) {
			var val = new GmapPoint();
			val.location = loc;
			val.color = col;
			val.stopNumber = stopNum;
			val.markerTypes = [];
			val.ids = ids;
			return val;
		}
		return null;
	}

	marker: google.maps.marker.AdvancedMarkerElement;
	pinElement: google.maps.marker.PinElement;
	clickFunction: Function;
	location?: google.maps.LatLngLiteral;
	markerTypes: GmapMarkerTypeEnum[] = [];
	color: string = '';
	stopNumber: string = '';
	count: number = 1;
	ids: string[] = [];
	items: any[] = [];
	getAsLocation(): google.maps.LatLngLiteral {
		return this.location;
	}

	getAsDirectionsWaypoint(): google.maps.DirectionsWaypoint {

		return {
			location: this.getAsLocation(),
			stopover: false
		} as google.maps.DirectionsWaypoint;
	}
}
export class GmapDirectionsDataHolder {
	Meters: number = 0;
	Minutes: number = 0;
	color: string = '';
	startingPoint: google.maps.LatLngLiteral;
	endingPoint: google.maps.LatLngLiteral;
	wayPoints: google.maps.DirectionsWaypoint[];
	onlyPoints: boolean = false;
	allPoints: GmapPoint[] = [];
	allMarkers: google.maps.marker.AdvancedMarkerElement[] = [];

	public straightLineHolder: google.maps.Polyline;
	public directionsResult: google.maps.DirectionsResult;
	public directionsRenderer: google.maps.DirectionsRenderer;
	public clearSubscription: Subscription;
	constructor(color: string, wPoints: GmapPoint[]) {
		this.color = color;
		if (wPoints.length) {
			this.allMarkers = [];
			this.allPoints = wPoints;
			this.startingPoint = wPoints[0].getAsLocation();
			this.endingPoint = wPoints[wPoints.length - 1].getAsLocation();
			this.wayPoints = [];
			if (wPoints.length > 2) {
				for (var i = 1; i < wPoints.length - 1; i++) {
					var wpoint = wPoints[i].getAsDirectionsWaypoint();
					wpoint.stopover = true;
					this.wayPoints.push(wpoint);
				}
			}
		}
	}

	addMarkers(useSymbols: boolean, imap: google.maps.Map, bounds: google.maps.LatLngBounds) {
		var map: google.maps.Map = imap;
		if (!map) {
			if (this.directionsRenderer) {
				map = this.directionsRenderer.getMap();
			}
		}
		if (!map) {
			if (this.straightLineHolder) {
				map = this.straightLineHolder.getMap();
			}
		}
		if (map) {
			if (this.allMarkers?.length) {
				this.allMarkers.forEach(mark => {
					mark.map = map;
					bounds.extend(mark.position);
				});
			} else {
				this.allMarkers = [];
				this.allPoints.forEach(pt => {
					if (pt.markerTypes?.length) {
						var itext = '';
						var ititle = '';
						if (pt.count < 2) {
							itext += pt.stopNumber;
							ititle += pt.stopNumber + ' ';
						}
						var isCompleted = 0;
						var isCancelled = 0;
						var isWarehouseOrCustomerLocation = pt.markerTypes.filter(a => a == GmapMarkerTypeEnum.IsWarehouseOrCustomerLocation).length > 0;
						var zIndexData = 1000;
						pt.markerTypes.forEach(mt => {
							switch (mt) {
								case GmapMarkerTypeEnum.Completed:
									isCompleted++;
									break;
								case GmapMarkerTypeEnum.Cancelled:
									isCancelled++;
									break;
								case GmapMarkerTypeEnum.Assembly:
									if (!isWarehouseOrCustomerLocation) {
										itext += 'A';
										ititle += 'With Assembly';
									}
									break;
								case GmapMarkerTypeEnum.Delivery:
									itext += useSymbols ? '\uf063' : 'D';
									ititle += 'Delivery';
									break;
								case GmapMarkerTypeEnum.Pickup:
									itext += useSymbols ? '\uf062' : 'P';
									ititle += 'Pickup';
									break;
								case GmapMarkerTypeEnum.Break:
									itext += useSymbols ? '\uf04d' : 'B';
									ititle += 'Break';
									break;
								case GmapMarkerTypeEnum.WarehousePickup:
									itext += 'W';
									ititle += 'Warehouse Pickup';
									break;
								case GmapMarkerTypeEnum.WarehouseDelivery:
									itext += 'W';
									ititle += 'Warehouse Delivery';
									break;
								case GmapMarkerTypeEnum.Start:
									itext += useSymbols ? '\uf04b' : 'S';
									ititle += 'Starting Place';
									zIndexData = 10;
									break;
								case GmapMarkerTypeEnum.ServiceOnly:
									itext += 'SO';
									ititle += 'Service Only';
									break;
								case GmapMarkerTypeEnum.Finish:
									itext += useSymbols ? '\uf28d' : 'E';
									ititle += 'Ending Place';
									zIndexData = 10;
									break;
								case GmapMarkerTypeEnum.Removal:
									itext += 'R';
									ititle += 'Removal';
									break;
								case GmapMarkerTypeEnum.Exchange:
									itext += 'X';
									ititle += 'Exchange';
									break;
								case GmapMarkerTypeEnum.NotifyItems:
									itext += '*';
									ititle += 'Notify Items';
									break;
							}
						});
						if (pt.count > 1) {
							itext += '+' + pt.count.toString();
							ititle += '-' + pt.count.toString() + ' stops';
						}

						if (!ititle.length) {
							ititle = 'tester tester';
						}
						var pinSVGFilled = "M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z";
						var viewPortPin = '0 0 24 24';
						var yPin = '40%';
						var xPin = '50%';
						var heightPin = 56; //multiples of 24
						var widthPin = 56;
						//https://itpscan.ca/blog/google_maps/maps_07a/
						var squaremarker = 'M0-165c-27.618 0-50 21.966-50 49.054C-50-88.849 0 0 0 0s50-88.849 50-115.946C50-143.034 27.605-165 0-165z';
						var starMarker = 'M15.422,18.129l-5.264-2.768l-5.265,2.768l1.006-5.863L1.64,8.114l5.887-0.855 l2.632-5.334l2.633,5.334l5.885,0.855l-4.258,4.152L15.422,18.129z';
						var viewPortStar = '0 0 16 19';
						var yStar = '55%';
						var xStar = '65%';
						var heightStar = 60; //multiples of 24
						var widthStar = 60;
						//view-source:http://itpscan.ca/blog/google_maps/maps_12/





						var borderColor = 'white';
						var opac = 1;
						if (pt.count < 2) {
							if (isCancelled) {
								borderColor += 'black';
							}
							if (isCompleted) {
								opac = .5;
							}
						}

						var yToUse = yPin;
						var xToUse = xPin;
						var viewportToUse = viewPortPin;
						var heightToUse = heightPin;
						var widthToUse = widthPin;
						var fontSize = "4px";
						var markerImageToUse = pinSVGFilled;
						var changeTypes = pt.markerTypes.filter(mt => GmapMarkerTypeEnum.Removal == mt || GmapMarkerTypeEnum.Exchange == mt || GmapMarkerTypeEnum.NotifyItems == mt);
						if (changeTypes.length > 0) {
							if (!isWarehouseOrCustomerLocation) {
								markerImageToUse = starMarker;
								fontSize = "3px";
								heightToUse = heightStar;
								widthToUse = widthStar;
								viewportToUse = viewPortStar;
								yToUse = yStar;
								xToUse = xStar;
							}
						}
						//https://stackoverflow.com/questions/2472957/how-can-i-change-the-color-of-a-google-maps-marker

						const pinSvgString =
							'<svg xmlns="http://www.w3.org/2000/svg"  height="' + heightToUse + '" width="' + widthToUse + '" viewBox="' + viewportToUse + '">' +
							'<path d="' + markerImageToUse + '" stroke="' + borderColor + '" fill="' + pt.color + '" ' +
							'stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> ' +
							'<text x="' + xToUse + '" y="' + yToUse + '" text-anchor="middle" dominant-baseline="middle" font-size="' +
							fontSize + '" fill="#fff" font-family="FontAwesome,Helvetica,Helvetica Neue,Arial">' + itext + '</text>' +
							'</svg>';

						const parser = new DOMParser();
						const pinSvg = parser.parseFromString(
							pinSvgString,
							'image/svg+xml'
						).documentElement;

						if (opac != 1) {
							pinSvg.style.opacity = opac.toString();
						}
						var loc = pt.getAsLocation()
						bounds.extend(loc);
						var mkr = new google.maps.marker.AdvancedMarkerElement({
							position: loc,
							// @ts-ignore
							anchorLeft: "-50%",
							anchorTop: "-100%",
							map: map,
							content: pinSvg,
							title: ititle,
							zIndex: zIndexData
						});

						if (pt.clickFunction) {
							mkr.gmpClickable = true;
							mkr.addListener('gmp-click', pt.clickFunction);
						} else {
							//mkr.gmpClickable = false;
						}
						this.allMarkers.push(mkr);
						pt.marker = mkr;
					}
				});
			}
		}
	}
	public clearMap() {
		if (this.directionsRenderer) {
			this.directionsRenderer.setMap(null);
		}
		if (this.straightLineHolder) {
			this.straightLineHolder.setMap(null);
		}
		if (this.clearSubscription) {
			this.clearSubscription.unsubscribe();
		}
		if (this.allMarkers?.length) {
			this.allMarkers.forEach(mark => {
				mark.map = null;
			});
		}
	}
	public buildDirectionsRequest(includeWalking: boolean): google.maps.DirectionsRequest {

		var tm = google.maps.TravelMode[google.maps.TravelMode.DRIVING];
		if (includeWalking) {
			tm = google.maps.TravelMode[google.maps.TravelMode.DRIVING, google.maps.TravelMode.WALKING];
		}
		const req = {
			origin: this.startingPoint,
			destination: this.endingPoint,
			waypoints: this.wayPoints,
			avoidHighways: false,
			travelMode: tm
		} as google.maps.DirectionsRequest;

		return req;
	};
}
